// helpers/domHelpers.ts

export function attachClickOutsideListener(
  ref: React.RefObject<HTMLElement>,
  onOutsideClick: () => void,
  shouldIgnore?: () => boolean
) {
  function handleClickOutside(event: MouseEvent) {
    if (shouldIgnore && shouldIgnore()) return;
    const target = event.target as Element;

    // Check if the drawer exists and the click is outside of it
    if (ref.current && !ref.current.contains(target)) {
      // Additional check to ensure we're not clicking on portal elements
      // This handles dropdowns that might be rendered in portals
      const isClickOnPortalElement =
        target.closest("[data-radix-popper-content-wrapper]") ||
        target.closest("[data-radix-select-content]") ||
        target.closest("[data-radix-dropdown-menu-content]") ||
        target.closest(".select-content") ||
        target.closest('[role="listbox"]');

      if (!isClickOnPortalElement) {
        onOutsideClick();
      }
    }
  }

  document.addEventListener("mousedown", handleClickOutside);

  // Return a cleanup function
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}
